module.exports = __webpack_public_path__ + "/img/product-basic__fallback-image.png";